module.exports = __webpack_public_path__ + "assets/img/businesses.b5f8e891.webp";